import { shellCard } from '@/pages/dashboard/components/dashboardTheme'

export type DashboardKpi = {
	label: string
	value: string
	hint?: string
	icon: string
	accentClass?: string
}

export function DashboardKpiGrid({ items }: { items: DashboardKpi[] }) {
	return (
		<div className="mb-6 grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
			{items.map((card) => (
				<div key={card.label} className={`${shellCard} px-4 py-4`}>
					<div className="mb-3 flex items-center justify-between gap-2">
						<span className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">{card.label}</span>
						<div className={`flex h-8 w-8 items-center justify-center rounded-lg bg-secondary/80 ${card.accentClass ?? 'text-primary'}`}>
							<i className={`${card.icon} text-base`} aria-hidden />
						</div>
					</div>
					<div className="font-display text-2xl font-semibold tracking-tight text-foreground">{card.value}</div>
					{card.hint ? <div className="mt-1 text-xs font-medium text-muted-foreground">{card.hint}</div> : null}
				</div>
			))}
		</div>
	)
}
